const state = {
  navCollapse: false,
  selectedNav: '',
  // Mobile off-canvas nav drawer (phones). Kept separate from navCollapse —
  // that flag is the desktop icon-rail toggle with 4 existing callers, and
  // overloading it here would fight them.
  drawerOpen: false,
  // Mobile filter-rail sheet (search pages). One flag shared by the company +
  // people search pages, which both mount the same <Sidebar>; only one is
  // routed at a time so a single flag is safe.
  filtersSheetOpen: false,
}

const mutations = {
  setNavCollapse(state) {
    state.navCollapse = !state.navCollapse;
  },
  setSelectedNav(state, payload) {
    state.selectedNav = payload;
  },
  setDrawerOpen(state, payload) {
    state.drawerOpen = payload;
  },
  setFiltersSheetOpen(state, payload) {
    state.filtersSheetOpen = payload;
  },
}

const actions = {

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}